module.exports = "<p>\n  request-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/request/request-form/request-form.component.html
// module id = ./src/app/recovery/request/request-form/request-form.component.html
// module chunks = main